import { ESupportTicketPriority } from "../../aiTickets.types";
import { InlineDropdown } from "../InlineDropdown";
import { PriorityPill } from "../PriorityPill";

interface Props {
  priority: ESupportTicketPriority;
  disabled?: boolean;
  onChange: (next: ESupportTicketPriority) => void;
}

const PRIORITY_OPTIONS: ESupportTicketPriority[] = [
  ESupportTicketPriority.Urgent,
  ESupportTicketPriority.Alert,
  ESupportTicketPriority.FollowUp,
  ESupportTicketPriority.Reminder,
  ESupportTicketPriority.Low,
];

const TypeCell = ({ priority, disabled, onChange }: Props) => (
  <InlineDropdown<ESupportTicketPriority>
    value={priority}
    disabled={disabled}
    onSelect={onChange}
    trigger={<PriorityPill priority={priority} />}
    options={PRIORITY_OPTIONS.map((p) => ({
      value: p,
      label: <PriorityPill priority={p} withChevron={false} />,
    }))}
  />
);

export default TypeCell;
